import React, { useState, useEffect } from 'react'
import Service from '@/services/member'
import './index.less'
import moment from 'moment'
import { message, Button, Spin } from 'antd'
import { searchToObj } from '@/utils/utils'

const gender = {
  1: '男',
  2: '女',
}

function showError() {
  message.error('未查询到相关证书')
}

export default (props) => {
  const {
    location: { search },
  } = props
  const params = searchToObj(search)
  const [data, setData] = useState({})
  const [step, setStep] = useState(1)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    Service.searchTrainCertificateByCode(params)
      .then((res) => {
        if (res.success && res.data?.code) {
          const record = res.data
          setData({
            ...record,
            birth: moment(record.birth).format('YYYY-MM'),
            detail: `${moment(record.trainStartDate).format('YYYY年MM月DD日')}至${moment(
              record.trainEndDate,
            ).format('YYYY年MM月DD日')}，参加了中国建筑业协会举办的${
              record.trainName
            }，培训时长${record.period}学时。`,
          })
        } else {
          showError()
        }
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    <Spin spinning={loading} size="large">
      <div className="container">
        <div className="header">个人培训证书查询</div>
        <div className="inner">
          {step === 1 && (
            <>
              <div className="item">
                <div className="title">证书编号</div>
                <div className="content">{data?.code}</div>
              </div>
              <div className="item">
                <div className="title">姓名</div>
                <div className="content">{data?.name}</div>
              </div>
              <div className="item">
                <div className="title">性别</div>
                <div className="content">{gender[data?.sex]}</div>
              </div>
              <div className="item">
                <div className="title">工作单位</div>
                <div className="content">{data?.workUnit}</div>
              </div>
              <div className="item">
                <div className="title">出生年月</div>
                <div className="content">{data?.birth}</div>
              </div>
              <div className="item">
                <div className="title">培训经历</div>
                <div className="content">{data?.detail}</div>
              </div>
            </>
          )}
          {step === 2 && <img src={data.certificateUrl} alt="" style={{ width: '100%' }} />}
        </div>
        <div className="footer">
          {step === 1 && (
            <Button type="primary" onClick={() => setStep(2)}>
              培训证书预览
            </Button>
          )}
          {step === 2 && (
            <Button type="primary" onClick={() => window.open(data.certificateUrl)}>
              培训证书下载
            </Button>
          )}
        </div>
      </div>
    </Spin>
  )
}
